import { gql } from "@apollo/client";

export const VALIDATE_MATRICULA_BY_ORIGEN = gql`
query ExisteMatriculaByOrigen($idOrigenMatricula: Int!, $numero: String!,$idTipoProfesional: Int!) {
    existeMatriculaProfesionalByOrigen(idOrigenMatricula: $idOrigenMatricula, numero: $numero, idTipoProfesional: $idTipoProfesional) 
}`;